// components/HttpErrorHandler.jsx
import { useHttpError } from '../context/HttpErrorContext';
import { Link } from 'react-router-dom';
import Layout from './Layout'; // whatever your layout/shell component is

const ReturnLink = () => (
  <Link to={-1}>Go Back</Link>
);

export const ServerError = () => (
  <section>
    <h1>500 - Server Error</h1>
    <p>Something went wrong on our end. Please try again later.</p>
  </section>
);

export const NotFound = () => (
  <section>
    <h1>404 - Not Found!</h1>
    <br />
    <ReturnLink />
  </section>
);

export const DuplicateAttendee = () => {
  <section>
    <h1>Oops</h1>
    <p>Our records show that you have previously signed up for this event.</p>
    <p>If you feel that you reached this page from an error, please contact support at <a href="mailto:support@baptistsonmission.org">Support</a></p>
  </section>
}

export const NotAuthorized = () => (
  <section>
    <h1>Oops!</h1>
    <p>Looks like you don't have access.</p>
    <br />
    <ReturnLink />
  </section>
);

const HttpErrorHandler = ({ children }) => {
  const { httpError } = useHttpError();

  if (!httpError) return children;

  const ErrorComponent = () => {
    switch (httpError?.response?.status) {
      case 403: return <NotAuthorized />;
      case 404: return <NotFound />;
      case 402: return <DuplicateAttendee/>
      case 500: return <ServerError />;
      default:  return <ServerError />;
    }
  };

  return (
    <Layout>
      <ErrorComponent />
    </Layout>
  );
};

export default HttpErrorHandler;